import { render, staticRenderFns } from "./ScbEasy copy.vue?vue&type=template&id=bea9e018&scoped=true"
import script from "./ScbEasy copy.vue?vue&type=script&lang=js"
export * from "./ScbEasy copy.vue?vue&type=script&lang=js"
import style0 from "./ScbEasy copy.vue?vue&type=style&index=0&id=bea9e018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea9e018",
  null
  
)

export default component.exports